import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ShipmentWaybillTrackingMapFacade } from './shipment-waybill-tracking-map.facade';
import { switchMap } from 'rxjs/operators';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { WaybillIdView } from '../../../../models/shipment-id-view.model';
import { ShipmentWaybillItemFacade } from '../shipment-waybill-item.facade';

@Injectable({
  providedIn: 'root',
})
export class ShipmentWaybillTrackingMapGuard {
  constructor(
    private shipmentWaybillTrackingMapFacade: ShipmentWaybillTrackingMapFacade,
    private shipmentWaybillItemFacade: ShipmentWaybillItemFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.shipmentWaybillItemFacade.shipmentWaybillIdentifier$.pipe(
      switchMap((identifier: WaybillIdView) => {
        return checkStoreState(this.shipmentWaybillTrackingMapFacade, identifier);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentWaybillTrackingMapFacade);
  }
}
